import {LoadAsset} from './LoadAsset.class';

export class LoadAssetGroup {
  public type;
  public loadAssetList;

  public resultList?: any[];
  public error?: Error;

  constructor({
    type,
    loadAssetList,
  }: {
    type: string;
    loadAssetList: LoadAsset[];
  }) {
    this.type = type;
    loadAssetList.forEach(loadAsset => {
      loadAsset.groupType = type;
    });
    this.loadAssetList = loadAssetList;
  }

  load = async () => {
    try {
      await Promise.allSettled(
        this.loadAssetList.map(loadAsset => loadAsset.load())
      );
      this.resultList = this.loadAssetList.map(loadAsset => loadAsset.result);
    } catch (error) {
      this.error = error;
    }
  };
}
